module.exports = "https://static.wanderu.com/static/media/multimodal-grey.0c591eaf.svg";